var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.fetchProcess)?_c('LoadingLayer'):_c('DashboardView',[(!_vm.contentState)?_c('div',[_vm._v(" You dont have permission to access this menu. ")]):_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }